"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavLink;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intentsConfig = _interopRequireDefault(require("../../../page-body/media-components/tab-carousel-section/intents.config.js"));
const NavLinkWrapper = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "NavLinkWrapper",
  class: "pl-njs63jk"
});
function NavLink({
  _name,
  title,
  href,
  anchor,
  onClick
}) {
  return /*#__PURE__*/_react.default.createElement(NavLinkWrapper, (0, _extends2.default)({
    href: href ? href : `#${anchor}`,
    "data-target": anchor ? anchor : '',
    onClick: onClick
  }, _patternLibraryUtils.tracking.create(_name, true, true)), title);
}
NavLink.propTypes = {
  _name: _propTypes.default.string,
  title: _propTypes.default.string,
  href: _propTypes.default.string,
  anchor: _propTypes.default.string,
  onClick: _propTypes.default.func
};